import React, { useEffect, useState } from "react";
import "./CheckoutHeader.css";
import "../../UniversalStyles.css";
import "./CheckoutHeaderText.css";
import {
  alarmIcon,
  headerLeftSideIllustration,
  headerRightSideIllustration,
  NFOLogo,
} from "../../Assets/svgs";
import { motion } from "framer-motion";
import SubtotalHeader from "../../Pages/ComponentsCheckoutPage/Components/Subtotal/SubtotalHeader";

interface CheckoutHeaderProps {}

const CheckoutHeader = (props: CheckoutHeaderProps) => {
  // const [timeLeft, setTimeLeft] = useState<number>(0);

  // useEffect(() => {
  //   // Check if there's an existing timer in localStorage
  //   const endTime = localStorage.getItem("countdownEndTime");

  //   if (!endTime) {
  //     // If no timer exists, set a new 10-minute timer
  //     const newEndTime = Date.now() + 10 * 60 * 1000; // 10 minutes in milliseconds
  //     localStorage.setItem("countdownEndTime", newEndTime.toString());
  //   }

  //   const timer = setInterval(() => {
  //     const endTimeMs = parseInt(
  //       localStorage.getItem("countdownEndTime") || "0"
  //     );
  //     const now = Date.now();
  //     const timeRemaining = Math.max(0, endTimeMs - now);

  //     if (timeRemaining === 0) {
  //       // Timer has expired
  //       localStorage.removeItem("countdownEndTime");
  //       clearInterval(timer);
  //     }

  //     setTimeLeft(timeRemaining);
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  // // Convert milliseconds to minutes and seconds
  // const minutes = Math.floor(timeLeft / (1000 * 60));
  // const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {/* {timeLeft > 0 ? (
        <div
          style={{
            backgroundColor: "#235188",
            width: "100%",
            maxHeight: "100px",
            position: "fixed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: "bold",
            zIndex: 1000,
            textAlign: "center",
            minHeight: "50px",
            padding: "5px 10px",
          }}
        >
          ⏳ Only {minutes}:{seconds < 10 ? `0${seconds}` : seconds} Left!
          <br /> Grab This Deal Before It’s Gone! 🚀
        </div>
      ) : (
        <div></div>
      )} */}
      <SubtotalHeader />
      <div
        style={{ marginTop: "40px" }}
        className="universal-checkout-header-parent"
      >
        <header className="universal-checkout-header">
          <div className="universal"></div>
          <img className="universal-NFO-logo" alt="NFOLogo" src={NFOLogo} />

          <div className="universal-header-background">
            <div className="header-content">
              <img
                src={headerLeftSideIllustration}
                className="header-illustration"
                alt="Header Illustration"
              />
              <div className="header-text">Checkout</div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default CheckoutHeader;
